export default __webpack_public_path__ + "static/media/hamburguer.6bbc4c10.svg";